import * as React from 'react';

const LivingArea = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M3.5 20.375V7.25M1.625 18.5 3.5 20.375 5.375 18.5M5.375 9.125 3.5 7.25 1.625 9.125M7.25 3.5h13.125M9.125 1.625 7.25 3.5l1.875 1.875M18.5 5.375 20.375 3.5 18.5 1.625M10.375 11.875v6c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-6" />
            <path d="M20.375 14.125 14.961 9.25a1.25 1.25 0 0 0-1.672 0l-5.414 4.875" />
        </g>
    </svg>
);
export default LivingArea;
